import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const cleanParams = (params = {}) => {
  const paramsToSend = { ...params };
  Object.keys(paramsToSend).forEach((key) => {
    if (paramsToSend[key] === "" || paramsToSend[key] === null || paramsToSend[key] === undefined) {
      delete paramsToSend[key];
    }
  });

  return paramsToSend;
};

const DashboardService = {
  async getAllRows() {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Dashboard`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement du dashboard partenaire",
      data: [],
    };
  },

  async getKpis(params = {}) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Dashboard/kpis`, { params: cleanParams(params) });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement des KPI du dashboard partenaire",
      data: null,
    };
  },

  async getAmountByDirection(params = {}) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Dashboard/amount_by_direction`, { params: cleanParams(params) });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement des montants par direction",
      data: [],
    };
  },

  async getTopPartners(params = {}) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Dashboard/top_partners`, { params: cleanParams(params) });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement du top partenaires",
      data: [],
    };
  },

  async getFinancements(params = {}) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Dashboard/financements`, { params: cleanParams(params) });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement des financements",
      data: [],
    };
  },

  async getPeriods() {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Partner/periods`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement des periodes",
      data: [],
    };
  },
  async getCIDetails(params = {}) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Dashboard/ci_details`, { params: cleanParams(params) });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: false,
      message: "Erreur de chargement du detail CI",
      data: [],
    };
  },
  async getPartnerDetails(params = {}) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Dashboard/partner_details`, { params: cleanParams(params) });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: false,
      message: "Erreur de chargement du detail partenaires",
      data: [],
    };
  },
};

export default DashboardService;
